var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedFilledDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#E9FCE4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9994 42.6664C27.6528 42.6664 27.3061 42.5331 27.0528 42.2798L20.3861 35.6131C19.8661 35.0931 19.8661 34.2531 20.3861 33.7331C20.9061 33.2131 21.7461 33.2131 22.2661 33.7331L27.9061 39.3731L41.6394 23.1464C42.1194 22.5864 42.9594 22.5198 43.5194 22.9864C44.0794 23.4664 44.1461 24.3064 43.6794 24.8664L29.0128 42.1998C28.7728 42.4798 28.4261 42.6531 28.0528 42.6664C28.0394 42.6664 28.0128 42.6664 27.9994 42.6664Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedFilledDark);
export default __webpack_public_path__ + "static/media/checked-filled-dark.0afeaf027c8c292b584ed5b436649f41.svg";
export { ForwardRef as ReactComponent };